/**
 *功能: 客户bs系统
 */
export default {
  $getway: 'OurwayGuestBusiness',
  getCurrentGuest: 'mainOrder/getCurrentGuest', // 库存账页数据字典号查询
  getCarPermission: 'mainOrder/getCarPermission', // 获取客户是否有装卸车权限显示装卸车区域
  // 统计接口
  getTankGoodsDic: 'statistics/getTankGoodsDic', // 库存账页数据字典号查询
  listAccountBooks: 'statistics/listAccountBooks', // 库存账页查询
  listCarList: 'statistics/listCarList', // 车辆排队情况查询
  listGoodsAndTank: 'statistics/listGoodsAndTank', // 当前库存查询
  listInOutCar: 'statistics/listInOutCar', // 汽车计量日报表查询
  getTank: 'statistics/getTank', // 罐号弹出选择
  getGoods: 'statistics/getGoods', // 产品弹出选择
  getRefGoods: 'mainOrder/getRefGoods', // 产品弹出选择
  getStateList: 'mainOrder/getStateList', // 获取单据状态
  // 台账接口
  mainOrderList: 'mainOrder/list', // 台帐
  getBargain: 'statistics/getBargain', // 合同号弹出选择
  mainOrderGetTGuest: 'mainOrder/getTGuest', // 提货人弹出选择
  getRefTGuest: 'mainOrder/getRefTGuest', // 提货人选择
  getTGuest: 'statistics/getTGuest', // 提货人弹出选择
  getTGuest2: 'statistics/getTGuest2', // 提货人弹出选择
  listExcelCarOrderList: 'mainOrder/listExcelCarOrderList', // 上传excel生成数据（车号细表）
  // 汽车收发货详情接口
  detail: 'mainOrder/detail', // 获取收发货详情
  getBlno: 'mainOrder/getBlno', // 提单号下拉
  getBargainByOrderType: 'mainOrder/getBargainByOrderType', // 合同号下拉
  getLocation: 'mainOrder/getLocation', // 附加合同号下拉
  getBatchNo: 'mainOrder/getBatchNo', // 批号列表
  getOutCarRefTGuest: 'mainOrder/getOutCarRefTGuest', // （装车）获取提货人
  getInCarTank: 'mainOrder/getInCarTank', // 卸车）罐号弹出选择
  getOutCarTank: 'mainOrder/getOutCarTank', // （装车）罐号弹出选择
  getInCarRefGoods: 'mainOrder/getInCarRefGoods', // （卸车）获取产品
  getOutCarRefGoods: 'mainOrder/getOutCarRefGoods', // （装车）获取产品
  getRefVGuest: 'mainOrder/getRefVGuest', // 客户弹出选择
  mainOrderGetBargainId: 'mainOrder/getBargainId', // 合同弹出选择
  // getServiceId: 'mainOrder/getServiceId', // 取装卸车服务编号
  getServiceId: 'mainOrder/getServiceIdByGuest', // 取装卸车服务编号
  getInCarBatchId: 'mainOrder/getInCarBatchId', // (卸车)批号列表
  getOutCarBatchId: 'mainOrder/getOutCarBatchId', // (装车)批号列表
  getAttachBargain: 'mainOrder/getOutCarAttachBargain', // 获取附加合同
  getAvailableDays: 'mainOrder/getAvailableDays', // 提单默认有效天数
  listCarOrderBatch: 'mainOrder/listCarOrderBatch', // 批号系表详情
  listCarOrderList: 'mainOrder/listCarOrderList', // 车号系表详情
  // 保存接口
  getRiskCtrlLevel: 'mainOrder/getRiskCtrlLevel',//下单获取风险等级
  save: 'mainOrder/save', // 主细表批量保存
  saveCarOrderBatchList: 'mainOrder/saveCarOrderBatchList', // 批号批量接口
  saveCarOrderListList: 'mainOrder/saveCarOrderListList', // 车号批量保存
  orderInsertToERP: 'mainOrder/orderInsertToERP', // 客户提单提交
  getListExcelCarOrderList: 'mainOrder/listExcelCarOrderList', // 上传excel生成数据（车号细表）
  orderValidateBeforeSave: 'mainOrder/orderValidateBeforeSave',//保存前校验
  // 撤回接口
  orderRevoke: 'mainOrder/orderRevoke', // 单据撤回接口
  //货权转移接口
  OW_Web_Get_Goods:'cargoTransfer/OW_Web_Get_Goods', //产品弹出选择
  OW_Web_Get_T_Guest:'cargoTransfer/OW_Web_Get_T_Guest',//客户弹出选择
  OW_Web_Get_OutGuest:'cargoTransfer/OW_Web_Get_OutGuest',//转出客户弹出选择
  OW_Web_Get_TankGoodsBargain:'cargoTransfer/OW_Web_Get_TankGoodsBargain',//合同弹出选择
  saveBargain:'cargoTransfer/saveBargain',//系表保存
  saveTransferGoods:'cargoTransfer/saveTransferGoods',//主单保存
  OW_WEB_Qry_TransferGoods:'cargoTransfer/OW_WEB_Qry_TransferGoods',//货权转移台账
  T_State:'cargoTransfer/T_State',//货权转移台账状态
  OW_Select_TransferGoodsTList:'cargoTransfer/OW_Select_TransferGoodsTList',//货权转移详情系表
  OW_WEB_Qry_OneTransferGoods:'cargoTransfer/OW_WEB_Qry_OneTransferGoods',//货权转移详情主表

  //订单查询接口
  getServiceForWeb:'ShipOrderLoading/DBBox_ServiceForWeb',//取服务编号

  //装卸船
  WEB_Get_BargainIDForKH:'ShipOrderLoading/WEB_Get_BargainIDForKH',//产品下拉
  getShips: 'ShipOrderLoading/Get_Ship', // 船名弹出选择
  getBargainShips: 'ShipOrderLoading/Get_BargainShip', // 船名弹出选择
  getShipSupplier:'ShipOrderLoading/Get_FSupplierByTypeShip',//船代弹出选择
  getGoodsSupplier: 'ShipOrderLoading/Get_FSupplierByTypeGoods',//货代弹出选择
  WEB_Get_CarOrderGoodsForKH:'ShipOrderLoading/WEB_Get_CarOrderGoodsForKH',//合同下拉
  DBBox_BLNO:'ShipOrderLoading/DBBox_BLNO',//提单号下拉
  DBBox_Base_BusinessDept:'ShipOrderLoading/DBBox_Base_BusinessDept',//商检部门
  Get_FSupplierByTypeGoods:'ShipOrderLoading/Get_FSupplierByTypeGoods',//货代弹出选择
  Get_FSupplierByTypeShip:'ShipOrderLoading/Get_FSupplierByTypeShip',//船代选择
  WEB_Get_CarOrderTankIDForKH:'ShipOrderLoading/WEB_Get_CarOrderTankIDForKH',//罐号下拉
  saveShip:'wshipOrderListController/saveAll',//船保存
  WEB_Select_ShipOrderList:'ShipOrderLoading/WEB_Select_ShipOrderList',//批号信息数据
  WEB_Insert_ERPCarOrder:'ShipOrderLoading/WEB_Insert_ERPCarOrder',//提交WEB订单到ERP
  shipDeatil:'ShipOrderLoading/detail',//详情
  //管线
  WEB_Select_PipeOrderList:'WpipeOrder/WEB_Select_PipeOrderList',
  pipeDeatil:'WpipeOrder/detail',//详情
  savePipe:'wpipeOrderListController/saveAll',//保存
  //转罐
  WEB_Select_TransferOrderIn:'WtransferOrder/WEB_Select_TransferOrderIn',
  WEB_Select_TransferOrderOut:'WEB_Select_TransferOrderOut',
  tansferDetail:'WtransferOrder/detail',//详情
  transferSave:'wtransferOrderInController/saveAll',//保存
};
